import React, { useState, useRef, useEffect, useContext } from "react";
import { getTableData } from "../../services/summaryReportsService";
import { SimpleTableChart } from "../charts/SimpleTableChart";
import { LoadingSpinner } from "../common/LoadingSpinner";
import { CodesToColorMapFunc } from "../../CodesToColorMap";
import { ChartContainerMessage } from "./ChartContainerMessage";
import { DiseaseGroupContext } from "../../contexts/diseaseGroupContext";

export const SimpleTableChartContainer = ({ code }) => {
	const [dataSet, setDataSet] = useState([]);

	const [def, setDef] = useState(null);
	const [hasErrored, setHasErrored] = useState(false);

	const { theme } = useContext(DiseaseGroupContext);

	const [cardTheme] = useState(CodesToColorMapFunc(code, theme));

	const mounted = useRef(false);

	const getData = (dateToGet) => {
		const then = (responseData) => {
			if (mounted.current === true) {
				setDataSet(responseData.data);
				setDef(responseData.def);
			}
		};

		if (dateToGet === null) {
			getTableData(code)
				.then(then)
				.catch((e) => {
					if (mounted.current === true) {
						setHasErrored(true);
					}
				});
		} else {
			getTableData(code, dateToGet)
				.then(then)
				.catch((e) => {
					if (mounted.current === true) {
						setHasErrored(true);
					}
				});
		}
	};

	useEffect(() => {
		mounted.current = true;
		getData();

		return () => {
			mounted.current = false;
		};
	}, []);

	if (hasErrored === true) {
		return (
			<ChartContainerMessage
				message={[
					"It has not been possible to retrieve your report.",
					"This is most likely because the connection to the internet has been lost.",
					"If this problem persists, please contact our helpdesk, quoting reference '#STC001'.",
				]}
			/>
		);
	}

	if (def === null) {
		return <LoadingSpinner asFullscreenOverlay={false} />;
	}

	// const gradient = `${cardTheme.from()} ${cardTheme.via()}`;
	const gradient = "from-white via-white";

	return (
		<div className={"h-full relative"}>
			<div className={"h-full relative"}>
				<div>
					<div
						className={
							"absolute top-3 left-0 right-0 bottom-4 px-3 overflow-auto pb-10"
						}
					>
						<SimpleTableChart dataSet={dataSet} def={def} />
					</div>
					<div
						className={`block absolute z-20 bottom-2 h-8 px-3 w-full bg-gradient-to-t ${gradient}`}
					>
						{" "}
					</div>
				</div>
			</div>
		</div>
	);
};
